import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import styles from "./../icon.css";
var IconCheckmark = function (_a) {
    var customStyle = _a.customStyle;
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: classNames(customStyle, styles.fill), width: "96", height: "96", viewBox: "0 0 96 96", children: _jsx("path", { "data-identifier": "check-path", fill: "none", stroke: "#FFF", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M19 53.5l17 17L78 28" }) }));
};
export default IconCheckmark;
